import React, { useEffect, useState } from 'react';
import { CreditCard, Heart, PauseCircle, PlayCircle, Archive, School, BadgeDollarSign } from 'lucide-react';
import { apiClient } from '../../api/client';

const EVENT_META = {
  subscription_activated: { icon: CreditCard, color: '#2EAA5C', label: (m) => `Subscription activated — ${m.plan || 'plan'}` },
  hearts_purchased: { icon: Heart, color: '#F5831F', label: (m) => `${m.hearts || '?'} Hearts purchased` },
  account_paused_90: { icon: PauseCircle, color: '#2563EB', label: () => 'Paused for 90 days' },
  account_paused_indefinite: { icon: Archive, color: '#7B4FD8', label: () => 'Hibernated (indefinite archive)' },
  account_reactivated: { icon: PlayCircle, color: '#2EAA5C', label: () => 'Account reactivated' },
  school_license_issued: { icon: School, color: '#7B4FD8', label: (m) => `School licence issued — ${m.school_name || 'school'} (${m.tier || ''}, $${((m.annual_amount_cents || 0) / 100).toLocaleString()}/yr)` },
  school_invoice_paid: { icon: BadgeDollarSign, color: '#2EAA5C', label: (m) => `School invoice paid — ${m.school_name || 'school'} (${m.invoice_number || ''}, $${((m.amount_cents || 0) / 100).toLocaleString()})` },
};

const timeAgo = (iso) => {
  if (!iso) return '';
  const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 60) return `${Math.max(mins, 0)}m ago`;
  if (mins < 1440) return `${Math.floor(mins / 60)}h ago`;
  return `${Math.floor(mins / 1440)}d ago`;
};

export const SubscriptionEventsFeed = () => {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    apiClient.request('/api/admin/stripe/events?limit=12')
      .then((res) => setEvents(res.events || []))
      .catch(() => setEvents([]));
  }, []);

  return (
    <div className="bg-white p-5 rounded-lg" style={{ border: '1px solid #E0E0E0' }} data-testid="subscription-events-feed">
      <h3 className="text-sm font-bold mb-3" style={{ color: '#1A1209' }}>Subscription Events</h3>
      {events === null && <p className="text-xs" style={{ color: '#6B6257' }}>Loading…</p>}
      {events !== null && events.length === 0 && (
        <p className="text-xs" style={{ color: '#6B6257' }}>No subscription events yet.</p>
      )}
      <div className="space-y-2 max-h-64 overflow-y-auto">
        {(events || []).map((ev, i) => {
          const meta = EVENT_META[ev.action] || { icon: CreditCard, color: '#666', label: () => ev.action };
          const Icon = meta.icon;
          return (
            <div key={`${ev.timestamp}-${i}`} className="flex items-start gap-2 text-sm" data-testid={`subscription-event-${i}`}>
              <Icon size={15} style={{ color: meta.color, marginTop: 2, flexShrink: 0 }} />
              <div className="min-w-0">
                <p className="truncate" style={{ color: '#1A1209' }}>{meta.label(ev.metadata || {})}</p>
                <p className="text-xs truncate" style={{ color: '#6B6257' }}>{ev.user_name} · {ev.user_email} · {timeAgo(ev.timestamp)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SubscriptionEventsFeed;
